import { render, staticRenderFns } from "./ActiveRequestsSidebar.vue?vue&type=template&id=5483d118&scoped=true"
import script from "./ActiveRequestsSidebar.vue?vue&type=script&lang=js"
export * from "./ActiveRequestsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ActiveRequestsSidebar.vue?vue&type=style&index=0&id=5483d118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5483d118",
  null
  
)

export default component.exports